export default "/assets/images/mila-filter-video-3.mp4?2ec8a24d27bd4caf40a2aad60e7a0ee2";